import { useSelector } from 'react-redux';

export const useActiveDeal = () => {
    const { deals = [], activated = [], prices = {} } = useSelector(({ activateDeals = {} }) => activateDeals);
    const current = deals?.[0] || null;

    if (current) {
        return {
            ...current,
            activated: activated.includes(parseInt(current.id, 10)),
            prices
        };
    }

    return current;
};
